import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../assets/images/loader.png'


const _hoisted_1 = { class: "flex items-start justify-center min-h-screen pt-24 text-center" }
const _hoisted_2 = {
  key: 0,
  class: "inset-0 bg-gray-lightest absolute z-50 opacity-80 flex justify-center items-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-header p-6 border-b" }
const _hoisted_6 = { class: "modal-title flex items-center text-textColor text-2xl w-full" }
const _hoisted_7 = {
  key: 0,
  class: "font-bold text-xl text-darkText"
}
const _hoisted_8 = { class: "ms-auto z-30" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Modal content here")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseIcon = _resolveComponent("CloseIcon")!

  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition ease-out duration-200 transform",
    "enter-from-class": "opacity-0",
    "enter-to-class": "opacity-100",
    "leave-active-class": "transition ease-in duration-200 transform",
    "leave-from-class": "opacity-100",
    "leave-to-class": "opacity-0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "modal-backdrop",
        class: "fixed z-50 backdrop-filter backdrop-blur-3px top-0 end-0 start-36 bottom-0 overflow-y-auto",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_Transition, {
            "enter-active-class": "transition ease-out duration-300 transform ",
            "enter-from-class": "opacity-0 translate-y-10 scale-95",
            "enter-to-class": "opacity-100 translate-y-0 scale-100",
            "leave-active-class": "ease-in duration-200",
            "leave-from-class": "opacity-100 translate-y-0 scale-100",
            "leave-to-class": "opacity-0 translate-y-10 translate-y-0 scale-95"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['w-' + _ctx.width, "relative bg-white rounded-0.5xl text-start shadow-xl shadow-mainShadow"]),
                role: "dialog",
                ref: "modal",
                "aria-modal": "true",
                "aria-labelledby": "modal-headline",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal($event, false)))
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.title)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.title), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", _hoisted_8, [
                      _createVNode(_component_CloseIcon, {
                        onClick: _ctx.closeModal,
                        class: "text-textColor"
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ]),
                _renderSlot(_ctx.$slots, "default", {}, () => [
                  _hoisted_9
                ])
              ], 2)
            ]),
            _: 3
          })
        ])
      ], 512)
    ]),
    _: 3
  }))
}